import * as authService from '../services/auth'
import { safeLocalStorage } from '../utils'
import { isMockApi } from './isMockApi'

const MOCK_SESSION_FLAG = 'informed_mock_api'

function toBase64Url(value) {
  return window
    .btoa(value)
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
}

function makeMockJwt() {
  const header = toBase64Url(JSON.stringify({ alg: 'none', typ: 'JWT' }))
  const payload = toBase64Url(
    JSON.stringify({
      userId: 'mock-user',
      email: 'dev@informed.local',
      exp: Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 365,
    })
  )
  return `${header}.${payload}.mock`
}

export function seedMockSession() {
  const cookieStorage = authService.makeCookieStorage()

  if (!isMockApi()) {
    if (cookieStorage.getItem(MOCK_SESSION_FLAG) === '1') {
      cookieStorage.clear()
    }
    return
  }

  authService.login({
    token: makeMockJwt(),
    refreshToken: 'mock-refresh',
    ssoToken: 'mock-sso',
    email: 'dev@informed.local',
  })
  cookieStorage.setItem(MOCK_SESSION_FLAG, '1')

  const storage = safeLocalStorage()
  if (storage && storage.setItem) {
    storage.setItem('showWalkthrough', true)
  }
}
